module.exports = __webpack_public_path__ + "static/img/pybk_gift_box.e1ef8e4.png";